// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  // AD B2C
  clientID: "9ab18ea8-b2d7-4fe2-8ff1-34e9fc3065c7", //for local development 
  clientIDAPI: 'a06131c6-5ee2-47bc-9fcf-3548d061c2cc', //for local development 
  authority: "https://diversitytrax2.b2clogin.com/diversitytrax2.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN",
  redirectURI: "https://diversitytrax2devui.z13.web.core.windows.net/dashboard",
  knownAuthorities: ["diversitytrax2.b2clogin.com"],
  logoutURI: "https://diversitytrax2devui.z13.web.core.windows.net/dashboard",
  loginFailedRoute: "/",
  b2cScopes: ["https://diversitytrax2.onmicrosoft.com/a06131c6-5ee2-47bc-9fcf-3548d061c2cc/user_impersonation"],
  graphURL: "https://graph.microsoft-ppe.com/v1.0/me",
  graphScopes: ["user.read"],
  baseAppUrl: "https://diversitytrax2devui.z13.web.core.windows.net/",
  // apiUrl: "Https://10000001.diversitytrax.us/api/",
  apiUrl: 'https://diversitytrax2-dev-api.azurewebsites.net/api/',
  azureBlobStorageName: "apiuistore",
  azureBlobStorageUrl: "https://apiuistore.blob.core.windows.net/",
  azureStorageContainer: "custom-ui",
  signUpAuthority: "https://diversitytrax2.b2clogin.com/diversitytrax2.onmicrosoft.com/",//SignUp Userflow
  editProfileAuthority: "",//Edit Profile Userflow
  changePasswordAuthority: "https://diversitytrax2.b2clogin.com/diversitytrax2.onmicrosoft.com/B2C_1_PASSWORDCHANGE",//Password change Userflow
  Signupflow: 'B2C_1_DTrax2.0-Email-SignUpOnly',
  logoImagePath: 'https://apiuistore.blob.core.windows.net/blob-anonymous/DivTrax2.0/DiversityLogoPNG.png',
  baseURL: 'https://dtrax2dev.diversitytrax.us',
  templateBaseUrl: 'https://apiuistore.blob.core.windows.net/blob-anonymous/DivTrax2.0/'
};
